export default __webpack_public_path__ + "static/media/health_connect.1110d3db.png";